import { utilities } from '@cornerstonejs/metadata';
export default utilities.isVideoTransferSyntax;
export const { videoUIDs } = utilities;
